module.exports = __webpack_public_path__ + "static/media/deardorff.c19c1af9.jpg";